import styled from "styled-components";

export const Action = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 15px;

  :first-child {
    margin-top: 15px;
  }

  :hover {
    cursor: pointer;
  }
`;
